import { useCallback } from "react";

import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { useAppDispatch } from "Store/hooks";

import { selectAdminAgentUrl } from "../serviceProcesses.selectors";
import { getServiceProcessesThunk } from "../thunks/getServiceProcesses.thunk";

export const useGetServiceProcesses = () => {
  const adminAgentUrl = useSelectorWithUrlParams(selectAdminAgentUrl);

  const dispatch = useAppDispatch();

  const getServiceProcesses = useCallback(() => {
    dispatch(
      getServiceProcessesThunk({
        adminAgentUrl
      })
    );
  }, [dispatch, adminAgentUrl]);

  return getServiceProcesses;
};
